<template>
    <i
        style="font-size: 18px; color: rgb(var(--orange))"
        class="iconsax"
        icon-name="warning-triangle"></i>
</template>
